import { render, staticRenderFns } from "./PressReleasesPage.vue?vue&type=template&id=32305443&scoped=true&"
import script from "./PressReleasesPage.vue?vue&type=script&lang=js&"
export * from "./PressReleasesPage.vue?vue&type=script&lang=js&"
import style0 from "./PressReleasesPage.vue?vue&type=style&index=0&id=32305443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32305443",
  null
  
)

export default component.exports